export default __webpack_public_path__ + "static/media/shang.f37881ea.png";